import AlchemyDisplayContent from 'components/AlchemyDisplayContent'
import { useVariableLoadedListener } from 'hooks/useVariableLoadedListener'
import { RowBetween } from 'layout/Components/Row'
import React, { useMemo, useRef, useState } from 'react'
import styled from 'styled-components'
import { Icons } from 'svgs'
import { colors } from 'theme/colors'
import Box from 'UIKit/Box/Box'
import { CardTitle } from 'views/Tournament'

interface TournamentRulesProps {
  rulesDescription?: string
}

const TournamentRules: React.FC<TournamentRulesProps> = ({ rulesDescription }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const contentRef = useRef<HTMLDivElement>(null)
  const contentElement = useVariableLoadedListener(() => contentRef.current)

  const maxHeight = useMemo(() => {
    if (!contentElement) return 0

    if (isExpanded) {
      return contentElement?.scrollHeight && contentElement.scrollHeight + 60
    }
    return 0
  }, [isExpanded, contentElement])

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev)
  }

  return (
    <StyledTournamentRules>
      <RowBetween onClick={toggleExpand} style={{ cursor: 'pointer' }}>
        <CardTitle>Tournament Rules</CardTitle>
        <Box
          style={{
            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease',
          }}
        >
          <Icons.ArrowDownIcon width="30px" height="30px" />
        </Box>
      </RowBetween>

      <StyledRulesDescription maxHeight={`${maxHeight}px !important`}>
        <StyledContentCSSWrap ref={contentRef}>
          <AlchemyDisplayContent my="16px" content={rulesDescription} />
        </StyledContentCSSWrap>
      </StyledRulesDescription>
    </StyledTournamentRules>
  )
}

const StyledTournamentRules = styled(Box)`
  padding: 20px;
  border-radius: 12px;
  background: ${colors.backgroundAlt5};
`

const StyledRulesDescription = styled(Box)`
  overflow: hidden;
  transition: 0.3s ease;
  max-height: 0px;
`

const StyledContentCSSWrap = styled(Box)`
  .html-container {
    * {
      color: ${({ theme }) => theme.colors.textTertiary};
      font-size: 14px;
    }
    a {
      color: ${({ theme }) => theme.colors.text};
    }
  }
`

export default TournamentRules
